module.exports = __webpack_public_path__ + "img/mission-mentoring-old.a6effca6.svg";